import { render } from "./PreavisStepsBar.vue?vue&type=template&id=1f12fa71&scoped=true&ts=true"
import script from "./PreavisStepsBar.vue?vue&type=script&lang=ts"
export * from "./PreavisStepsBar.vue?vue&type=script&lang=ts"

import "./PreavisStepsBar.vue?vue&type=style&index=0&id=1f12fa71&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f12fa71"]])

export default __exports__